import React, { useEffect } from 'react'
import { useSettings } from './useSettings'
import { ResultFilterEnum } from '../types/types'
import { getFilterCount, getEmptySampleFilters } from '../utils/filterUtils'

export type StatusFilter<T> = T[]

export interface Filters<T extends string> {
  planIds?: string[]
  taskIds?: string[]
  subPlanIds?: string[]
  productIds?: string[]
  matrixIds?: string[]
  sampntTypeIds?: string[]
  purposeIds?: string[]
  subPurposeIds?: string[]
  sampleIds?: string[]
  substanceIds?: string[]
  status?: StatusFilter<T>
  result?: ResultFilterEnum
  ownerId?: string
  regionId?: string
  avdelingId?: string
  seksjonId?: string
  teamId?: string
  userId?: string
  sampleId?: string
  searchText?: string
  producerSearch?: string
  labId?: string
  fromDate?: string
  toDate?: string
}

type UseFilters<T extends string> = () => {
  filters: Filters<T>
  setFilters: React.Dispatch<React.SetStateAction<Filters<T>>>
  isFiltering: boolean
  isReady: boolean
}

const defaultFilters = getEmptySampleFilters

export const useFilters = <T extends string>(
  prefix:
    | 'filterCombinations'
    | 'filtersTasks'
    | 'filterRequisitions'
    | 'filterPlanSamples'
    | 'filterTakeSamples'
    | 'filterPlans'
): ReturnType<UseFilters<T>> => {
  const settings = useSettings()
  const [defaultHasBeenSet, setDefaultHasBeenSet] =
    React.useState<boolean>(false)
  const filterSettings = settings.get?.[prefix]
  const [isInitial, setIsInitial] = React.useState<boolean>(true)
  const [filters, setFilters] = React.useState<Filters<T>>(defaultFilters())
  useEffect(() => {
    if (
      JSON.stringify(filters) != JSON.stringify(filterSettings) &&
      settings.isSuccess &&
      !isInitial
    ) {
      settings.set?.({ [prefix]: filters })
    }
  }, [filters])
  useEffect(() => {
    setIsInitial(false)
    if (filterSettings && settings.isSuccess) {
      setFilters(filterSettings as Filters<T>)
    } else if (!defaultHasBeenSet && settings.isSuccess) {
      setFilters(defaultFilters())
      setDefaultHasBeenSet(true)
    }
  }, [settings.isSuccess])

  return {
    filters,
    setFilters,
    isReady: settings.isSuccess && !isInitial,
    isFiltering: getFilterCount(filters) > 0
  }
}
